import React from "react";
import ReportManager, {
  totalsColumns,
  totalsTransformer,
} from "commons/components/ReportManager";

const filters = [
  { type: "select", name: "facilities", key: "facility_id" },
  {
    type: "select",
    name: "users",
    key: "user_id",
    extras: { optionLabel: "username" },
  },
  { type: "select", name: "customers", key: "customer_id" },
];

const columns = [
  {
    name: "customer",
    type: "text",
  },
  {
    name: "policy",
    type: "text",
  },
  ...totalsColumns,
  {
    name: "profit",
    type: "money",
  },
];

const byCustomerID = (record) => record.customer_id + "";

export default function SalesByCustomer() {
  return (
    <ReportManager
      url="sales"
      title="salesByCustomer"
      filterByDate
      filters={filters}
      columns={columns}
      totals={[
        "number_of_operations",
        "subtotal",
        "discount",
        "tax",
        "total",
        "cost",
        "profit",
      ]}
      recordsFunc={totalsTransformer(byCustomerID, "customer_id")}
    />
  );
}
